import { combineReducers } from 'redux'

import pacoReducers, { Reducers as PacoReducers } from '../@paco/redux/reducers'

import absencesReducer from './absences/absencesReducer'
import appReducer from './app/appReducer'
import { AppReducer } from './app-ts/appModels'
import authenticationReducer from './authentication/authenticationReducer'
import documentsReducer from './documents/documentsReducer'
import { DocumentsReducer } from './documents-ts/documentsModels'
import exchangesReducer from './exchanges/exchangesReducer'
import feedbackReducer from './feedback/feedbackReducer'
import preferenceReducer from './preferences/preferenceReducer'
import registrationReducer from './registration/registrationReducer'
import shiftReducer from './shift/shiftReducer'
import { ShiftReducer } from './shift-ts/shiftModels'
import shiftsReducer from './shifts/shiftsReducer'
import trackReducer from './track/trackReducer'
import tracksReducer from './tracks/tracksReducer'
import userReducer from './user/userReducer'
import { UserReducer } from './user-ts/userModels'

export interface Reducers extends PacoReducers {
    appReducer: AppReducer;
    authenticationReducer: any;
    tracksReducer: any;
    trackReducer: any;
    shiftsReducer: any;
    shiftReducer: ShiftReducer;
    exchangesReducer: any;
    absencesReducer: any;
    userReducer: UserReducer;
    feedbackReducer: any;
    registrationReducer: any;
    documentsReducer: DocumentsReducer;
    preferenceReducer: any;
}

export default combineReducers({
    appReducer,
    authenticationReducer,
    tracksReducer,
    trackReducer,
    shiftsReducer,
    shiftReducer,
    exchangesReducer,
    userReducer,
    absencesReducer,
    feedbackReducer,
    registrationReducer,
    documentsReducer,
    preferenceReducer,
    ...pacoReducers,
})
